"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
/**
 * Returns a method that wraps the original one with an async debounce
 * @param method The method that should be debounced
 * @param debounceMs The timeout in millisecs
 */
const debounce = (method, debounceMs = 250) => {
    let timeout;
    return ((...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            method(...args);
            clearTimeout(timeout);
            timeout = undefined;
        }, debounceMs);
    });
};
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map